const d = {
    toto(v, k = 'pathname') {
        const url = new URL(v)
        const is_internal = url.host.includes('suisseconsulences.ch')
        return is_internal ? url[k] : v
    }
}

export default d